// @flow
// $FlowFixMe
import React from 'react';
import {TripBoardsModalApolloProvider} from '@homeaway/react-trip-board-button';
import Experiment from '@homeaway/react-experiment';
import LoginExperience from '../LoginExperience/LoginExperience';
import {HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} from '../../abacus/experiments';
type TripBoardsProviderContainerProps = {
    locale: string,
    siteName: string,
    brand: string,
    isLoggedIn: boolean,
    tripBoardProviderSearchParams: Object
};
export default function TripBoardsProviderContainer({
    siteName,
    tripBoardProviderSearchParams,
    isLoggedIn,
    locale,
    brand
}: TripBoardsProviderContainerProps) {
    return isLoggedIn ? (
        <TripBoardsModalApolloProvider
            siteName={siteName}
            {...tripBoardProviderSearchParams}
            isLoggedIn={isLoggedIn}
            autosave
        />
    ) : (
        <Experiment name={HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} deferLogging>
            {({On, Off}) => (
                <React.Fragment>
                    <On>
                        <TripBoardsModalApolloProvider
                            siteName={siteName}
                            {...tripBoardProviderSearchParams}
                            isLoggedIn={isLoggedIn}
                            autosave
                            renderInitialModal={(
                                onComplete,
                                onClose,
                                isOpen
                            ) => {
                                return (
                                    isOpen && (
                                        <LoginExperience
                                            modalMode
                                            locale={locale}
                                            actionLocation="heartButtonLogin"
                                            site={siteName}
                                            siteName={brand}
                                            handleCloseModal={onClose}
                                            handleLoginSuccess={onComplete}
                                            configContext="savetripboard"
                                        />
                                    )
                                );
                            }}
                        />
                    </On>
                    <Off>
                        <TripBoardsModalApolloProvider
                            siteName={siteName}
                            {...tripBoardProviderSearchParams}
                            isLoggedIn={isLoggedIn}
                            autosave
                        />
                    </Off>
                </React.Fragment>
            )}
        </Experiment>
    );
}
